import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { Grid } from "@mui/material";
import { FileDownloadOutlined, FileUpload, Delete } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import { parse } from "src/common/utils";
import moment from "moment";
import { saveAs } from "file-saver";
import { UtilsService } from "src/services";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    paddingLeft: theme.spacing(2),
  },
  title: {
    fontWeight: "bold !important",
  },
  warningFile: {
    fontWeight: "bold !important",
    paddingLeft: theme.spacing(2),
  },
}));

function FilesUploader(props) {
  const { data, accept, maximumFileSize, isViewMode, onComplete } = props;

  const classes = useStyles();
  const [fileList, setFileList] = useState([]);
  const [buttonFileID, setButtonFileID] = useState("");
  const { t } = useTranslation();
  
  useEffect(() => {
    setButtonFileID(uuidv4());
  }, []);

  useEffect(() => {
    setFileList(data || []);
  }, [data]);

  const handleUploadChange = (event) => {
    const temp = [];
    Array.from(event.target.files).forEach((file) => {
      temp.push({
        name:
          file.name.split(".")[0] +
          "_" +
          moment().format("YYYYMMDDHHMMSSsss") +
          "." +
          file.name.split(".")[file.name.split(".").length - 1],
        path: URL.createObjectURL(file),
        size: file.size,
        file: file,
      });
    });
    setFileList([...fileList, ...temp]);
    onComplete([...fileList, ...temp]);
  };

  const downloadFile = (index) => {
    const file = fileList.find((item, i) => i === index);
    UtilsService.getFileBase64(file.path).then((resp) => {
      saveAs("data:application/octet-stream;base64," + resp, file.name);
    });
  };

  const deleteFile = (index) => {
    const temp = fileList.filter((item, i) => i !== index);
    setFileList(temp);
    onComplete(temp);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <input
                disabled={isViewMode}
                id={buttonFileID}
                key={uuidv4()}
                type="file"
                accept={accept}
                style={{ display: "none" }}
                onChange={handleUploadChange}
                multiple
              />
              <label htmlFor={buttonFileID}>
                <Button
                  disabled={isViewMode}
                  variant="contained"
                  color="primary"
                  component="span"
                  startIcon={<FileUpload />}
                  style={{ width: "100%" }}
                >
                  Upload Files
                </Button>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <ul className={classes.warningFile} key={uuidv4()}>
                <li>{t("VendorSelf.otherDesc1")} {parse.formatBytes(maximumFileSize)}</li>
                <li>{t("VendorSelf.otherDesc2")} {accept} {t("VendorSelf.otherDesc3")}</li>
              </ul>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          {fileList.length > 0 && <>{fileList.length} Files</>}
          {fileList &&
            fileList.map((tempFile, i) => (
              <Grid container spacing={2} key={uuidv4()}>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                  <img
                    style={{ width: "60px", height: "60px" }}
                    src={
                      (tempFile.name || "").match(/.(jpg|jpeg|png|gif)$/i)
                        ? (tempFile.path || "")
                        : "/images/icons/Document-Icon-Blue_imagelarge.png"
                    }
                  />
                </Grid>
                <Grid item xs={10} sm={10} md={8} lg={8}>
                  <p
                    style={{
                      paddingLeft: "10px",
                      fontSize: "22px",
                      fontWeight: "bold",
                    }}
                  >
                    {tempFile.name}
                  </p>
                  <p style={{ paddingLeft: "10px", fontSize: "18px" }}>
                    {parse.formatBytes(tempFile.size)}
                  </p>
                </Grid>
                <Grid item xs={2} sm={2} md={1} lg={1}>
                  <IconButton
                    onClick={() => {
                      downloadFile(i);
                    }}
                  >
                    <FileDownloadOutlined fontSize="medium" />
                  </IconButton>
                </Grid>
                <Grid item xs={2} sm={2} md={1} lg={1}>
                  <IconButton
                    disabled={isViewMode}
                    onClick={() => {
                      deleteFile(i);
                    }}
                  >
                    <Delete fontSize="medium" />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </div>
  );
}

FilesUploader.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  accept: PropTypes.string,
  maximumFileSize: PropTypes.number,
  isViewMode: PropTypes.bool,
};

export default FilesUploader;
